import React, { useEffect, useState } from 'react'

const RECAPTCHA_SITE_KEY = '6LeGSigrAAAAAL-VmyCLRmBO0YqR77JzaRWgO7xh'

export const withRecaptcha = (WrappedComponent, defaultAction = 'submit') => {
  const RecaptchaHOC = (props) => {
    const [ready, setReady] = useState(false)

    useEffect(() => {
      const existingScript = document.querySelector('script[src*="recaptcha/enterprise"]')
      if (existingScript) {
        setReady(true)
        return
      }

      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`
      script.async = true
      script.onload = () => setReady(true)
      document.body.appendChild(script)
    }, [])

    const withRecaptchaHandler = (originalHandler, action = defaultAction) => {
      return async (...args) => {
        if (!ready || !window.grecaptcha) {
          alert("reCAPTCHA not ready")
          return
        }

        try {
          const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action })
          // NOTE: Call original handler with the token injected
          originalHandler(token, ...args)
        } catch (err) {
          console.error("reCAPTCHA failed", err)
        }
      }
    }

    return (
      <WrappedComponent
        {...props}
        recaptchaReady={ready}
        withRecaptchaHandler={withRecaptchaHandler}
      />
    )
  }

  return RecaptchaHOC
}
